import { render, staticRenderFns } from "./ActualityPostCard.vue?vue&type=template&id=01aa4b48&scoped=true&"
import script from "./ActualityPostCard.vue?vue&type=script&lang=js&"
export * from "./ActualityPostCard.vue?vue&type=script&lang=js&"
import style0 from "./ActualityPostCard.vue?vue&type=style&index=0&id=01aa4b48&prod&scoped=true&lang=scss&"
import style1 from "./ActualityPostCard.vue?vue&type=style&index=1&id=01aa4b48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa4b48",
  null
  
)

export default component.exports